export interface IFeatureSectionConfig {
    title: string;
    keys: string[];
}

export const FEATURE_SECTIONS: IFeatureSectionConfig[] = [
    {
        title: 'Разделы',
        keys: [
            'section.home',
            'section.students',
            'section.calendar',
            'section.finance',
            'section.profile',
            'section.work_tgs',
            'section.student_tags',
            'section.staff',
            'section.tutors',
        ]
    },
    {
        title: 'Исполнитель',
        keys: [
            'students.view.tutor',
            'calendar.tutor.read',
            'tutors.finance.read',
            'tutors.payouts.read',
            'tutors.receipts.read',
            'tutors.penalties_bonuses.self.read',
            'profile.payment_details.read',
            'profile.payment_details.update',
        ]
    },
    {
        title: 'Графики',
        keys: [
            'schedule.tutor_availability.update',
            'schedule.student_regular.update',
            'schedule.student_regular.delete',
        ]
    },
    {
        title: 'Главная',
        keys: [
            'home.payment_landing.search',
        ]
    },
    {
        title: 'Документы',
        keys: [
            'idm.contract.read',
            'idm.contract.update',
        ]
    },
    {
        title: 'Студенты',
        keys: [
            'students.view.full',
            'students.list',
            'student_archive',
            'students.create',
            'change_all_students_payment',
            'student.card.read',
            'student.card.tutor.change',
            'student.card.archive',
            'student.card.unarchive',
            'student.card.update',
            'student.card.delete',
            'student.card.payment.update',
            'student.card.wallet.update',
            'student.card.payment_link.copy',
            'students.tags.student.list',
            'students.tags.assign',
            'students.tags.remove',
            'student.card.finance.read',
            'students.lessons.list',
            'students.transactions.list',
            'students.transactions.manual.create',
            'student.card.comments.read',
            'student.card.comments.create',
        ]
    },
    {
        title: 'Рабочие ТГ',
        keys: [
            'work_tgs.list',
            'work_tgs.create',
            'work_tgs.update',
            'work_tgs.delete',
            'work_tgs.assign_user',
        ]
    },
    {
        title: 'Теги студентов',
        keys: [
            'students.tags.list',
            'students.tags.create',
            'students.tags.update',
            'students.tags.delete',
        ]
    },
    {
        title: 'Финансы',
        keys: [
            'finance.list',
            'finance.view.full',
            'finance.view.partial',
            'finance.details.download',
            'finance.contracts.download_all',
            'finance.receipts.download_all',
            'salary',
            'transactions.list',
            'transactions.manual.create',
        ]
    },
    {
        title: 'Юридическая информация',
        keys: [
            'legal_info.read',
            'legal_info.manage',
            'legal_documents.read',
            'legal_documents.manage',
        ]
    },
    {
        title: 'Сотрудники',
        keys: [
            'idm.staff.list',
            'idm.staff.read',
            'idm.staff.create',
            'idm.staff.delete',
            'idm.staff.archive',
            'idm.staff.unarchive',
            'idm.staff.payment_details.update',
            'idm.user_password.reset',
            'staff.personal.read',
            'idm.staff.update',
            'idm.work_tgs.update',
            'staff.penalties_bonuses.read',
            'staff.penalties_bonuses.create',
            'idm.roles.list',
            'idm.features.list',
            'idm.role_features.list',
            'idm.role_features.add',
            'idm.role_features.remove',
            'idm.user_features.list',
            'idm.user_available_features.list',
            'idm.user_roles.assign',
            'idm.user_roles.remove',
            'idm.user_features.grant',
            'idm.user_features.revoke',
            'idm.user_features.targets.replace',
            'idm.user_relations.add',
            'idm.user_relations.delete',
        ]
    },
    {
        title: 'Исполнители',
        keys: [
            'tutors.list',
            'tutor_archive',
            'tutors.read',
            'tutor_update',
            'tutors.delete',
            'tutors.lessons.conduct',
            'tutors.students.transfer',
            'tutors.archive',
            'tutors.unarchive',
            'tutors.finance.read',
            'tutors.payouts.create',
            'tutors.payouts.cancel',
            'tutors.payouts.read',
            'tutors.receipts.create',
            'tutors.receipts.delete',
            'tutors.lessons.list',
            'tutors.contract.read',
            'tutors.contract.update',
            'tutors.penalty_bonus.read',
            'tutors.penalties_bonuses.read',
            'tutors.penalties_bonuses.create',
            'tutors.students.read',
        ]
    },
]
